<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Update Service Package</h4>
            <div class="modal-header--actions">
                <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                    <md-icon>clear</md-icon>
                </md-button>
            </div>
        </div>
        <div class="modal-body">
            <div>
                <p class="description">
                    Original Service Package:
                    <strong>{{ originalRateGroup != null ? originalRateGroup : 'None' }}</strong>
                </p>
            </div>
            <charging-type-options
                class="charging-type-options"
                :selected-charge-type-id="selectedRateGroupId"
                label-name=""
                :service-packages="servicePackages"
                @selectedOption="servicePackageChanged"
                ref="chargingType"
            ></charging-type-options>
        </div>
        <div class="modal-footer">
            <md-button class="dialog-button md-primary" @click.stop="updateServicePackage">
                Update
            </md-button>
            <md-button class="dialog-button md-default" @click.stop="$modal.hide">Cancel</md-button>
        </div>
    </div>
</template>
<script>
import { handleRequests, showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins';
import ChargingTypeOptions from '@/components/ChargingTypeOptions';
import { mapGetters } from 'vuex';

export default {
    name: 'UpdateServicePackageModal',
    components: { ChargingTypeOptions },
    props: {
        resolve: {
            type: Function,
            default: () => {}
        },
        jobType: {
            type: String,
            default: null // trip, shipment, or stop
        },
        rateGroupId: {
            type: Number,
            default: null
        },
        tripIds: {
            type: Array,
            default: () => []
        },
        stopIds: {
            type: Array,
            default: () => []
        },
        shipmentIds: {
            type: Array,
            default: () => []
        },
        orderIds: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            servicePackages: [],
            originalRateGroupId: this.rateGroupId,
            originalRateGroup: null,
            selectedRateGroupId: this.rateGroupId,
            selectedRateGroup: null
        };
    },
    computed: {
        ...mapGetters({
            getServicePackages: 'processCharges/getServicePackages'
        })
    },
    beforeMount() {
        this.servicePackages = this.getServicePackages;
        this.selectedRateGroupId = this.rateGroupId;
    },
    mounted() {
        if (this.rateGroupId != null) {
            const found = this.servicePackages.find((sp) => sp.rateGroupId === this.rateGroupId);

            if (found) {
                this.originalRateGroup = found.rateGroupName;
            }
        }
    },
    mixins: [GeneralMixin],
    methods: {
        async updateServicePackage() {
            this.resolve(true);
            const toUpdate = {
                rateGroupId: this.selectedRateGroupId ?? null,
                tripIds: this.tripIds ?? [],
                stopIds: this.stopIds ?? [],
                shipmentIds: this.shipmentIds ?? [],
                orderIds: this.orderIds ?? []
            };
            const payload = {
                method: 'patch',
                data: toUpdate
            };

            const endpoint = `/api/process-charges/update-service`;
            try {
                await handleRequests(endpoint, payload);
            } catch (e) {
                const message = `Cannot update service packages.`;
                showErrorMessage(this, message, e);
            }
        },
        servicePackageChanged(item) {
            this.selectedRateGroupId = item.rateGroupId;
            this.selectedRateGroup = item;
        }
    }
};
</script>

<style scoped lang="scss">
.form-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
}

.charging-type-options {
    ::v-deep .vs__dropdown-menu {
        height: 200px;
    }
}

.description {
    font-size: 14px;
    color: #3c4858;
}
</style>
